import _ from 'lodash';

import addAdmissionGroupPaymentRequestsPanelTemplate from 'panels/addAdmissionGroupPaymentRequests/template.html';

function Directive() {
  return {
    restrict: 'E',
    scope: {
      //TODO: all of this STATE is why we should use something like Vuex
      paymentRequests: '=',
      venue: '=',
      admissionGroup: '=',
      date: '=',
      outgoingPayment: '=',
      handle: '='
    },
    template: `<div class="payment-requests-panel">
      <button class="btn btn-default btn-block add-payment-request-btn clearfix" ng-click="addPaymentRequest(null, $event)">
        <span class="text pull-left">
          Request Payment
        </span>
        <i class="icon ion-plus"></i>
      </button>
      <div class="divider-section">
        <p>
          Payment Links ({{ paymentRequests.length || 0 }})
        </p>
      </div>
      <div class="payment-request clearfix" ng-repeat="request in paymentRequests" ng-click="addPaymentRequest(request, $event)">
        <div class="amount pull-left">
          {{ request.paymentAmount || 0 | currency }} - {{ request.name }}
        </div>
        <div class="status pull-right">
          <span class="completed" ng-if="request.status === 'COMPLETED'">
            Completed <i class="ion-checkmark"></i>
          </span>
          <span class="cancelled" ng-if="request.status === 'CANCELLED'">
            Cancelled
          </span>
          <span ng-if="request.status === 'PENDING'">Pending</span>
        </div>
        <i class="icon ion-chevron-right"></i>
      </div>
      <div class="divider-section" ng-if="outgoingPayment">
        <p>
          Prepaid Credit Card
        </p>
      </div>
      <wex-card outgoing-payment="outgoingPayment" ng-if="outgoingPayment"></wex-card>
    </div>`,
    controller: [
      '$scope',
      'angularSlideOutPanel',
      'alertService',
      ($scope, angularSlideOutPanel, alertService) => {
        $scope.addPaymentRequest = function (paymentRequest, $event) {
          if ($event) $event.preventDefault();

          const panelInstance = angularSlideOutPanel.open({
            template: addAdmissionGroupPaymentRequestsPanelTemplate,
            openOn: 'right',
            controller: 'addAdmissionGroupPaymentRequestsPanelCtrl',
            backdrop: 'static',
            resolve: {
              venue: [
                () => {
                  return $scope.venue;
                }
              ],
              admissionGroup: [
                () => {
                  return $scope.admissionGroup;
                }
              ],
              date: [
                () => {
                  return $scope.date;
                }
              ],
              paymentRequest: [
                () => {
                  return paymentRequest || null;
                }
              ]
            }
          });

          panelInstance.result
            .then(result => {
              if (result.paymentRequest) {
                if (result.canceled) {
                  const foundPaymentRequest = _.findWhere(this.paymentRequests, {
                    id: result.paymentRequest.id
                  });

                  if (foundPaymentRequest) _.extend(foundPaymentRequest, result.paymentRequest);

                  alertService.success('Payment Request Cancelled');
                } else {
                  this.paymentRequests = this.paymentRequests || [];
                  this.paymentRequests.push(result.paymentRequest);

                  this.addPaymentRequest(result.paymentRequest);

                  alertService.success('Payment Request Created');
                }
              }
            });
        };

        $scope.handle = $scope.handle || {};
        $scope.handle.addPaymentRequest = $scope.addPaymentRequest;
      }
    ]
  };
}

Directive.$inject = [];

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/paymentRequestsPanel.js